<template>
  <a
    v-if="elementType === 'link'"
    title="Store Directions"
    class="cf-link"
    target="_blank"
    :href="href"
  >
    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-8">
      <span
        v-if="displayIcon"
        class="cf-icon far fa-directions"
      />

      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--black">
        {{ address.line1 }},

        <template v-if="address.line2">
          {{ address.line2 }}
        </template>
        <template
          v-if="showLandmarkOrCrossStreet && address.landmarkOrCrossStreet"
        >
          ({{ address.landmarkOrCrossStreet }})
        </template>

        {{ address.city }},
        {{ address.state }}
        {{ address.postalCode }}
      </p>
    </div>
  </a>

  <a
    v-else
    title="Store Directions"
    target="_blank"
    :href="href"
    :class="['cf-button cf-button--tertiary', { 'cf-button--fixed-32': !showButtonContent }]"
  >
    <span class="cf-icon far fa-directions" />

    <p
      v-if="showButtonContent"
      class="cf-subtitle cf-subtitle--2 cf-subtitle--black"
    >
      Store Directions
    </p>

    <span class="ada-text">
      Store Directions
    </span>
  </a>
</template>


<script>
  export default {
    name: 'CfStoreDirections',

    props: {
      elementType: {
        type: String,
        default: 'button'
      },

      address: {
        type: Object,
        required: true
      },

      displayIcon: {
        type: Boolean,
        default: true
      },

      showButtonContent: {
        type: Boolean,
        default: true
      },

      showLandmarkOrCrossStreet: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      href() {
        const query = [
          this.address.line1,
          this.address.city,
          this.address.state,
          this.address.postalCode
        ].join(', ');

        return this.address.mapsUrlOverride || `https://www.google.com/maps/dir/?api=1&destination=${query}`;
      }
    }
  };
</script>
